export const MqTablet = '@media screen and (min-width: 768px)';

export const MqDesktop = '@media screen and (min-width: 1024px)';

export const MqWide = '@media screen and (min-width: 1440px)';

/**
  ☢️☢️☢️Use only if all other options don't work for you☢️☢️☢️
 **/
export const MqMobileOnly = '@media screen and (max-width: 767px)';
